/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class FinAiAgentSalesDeployRoute extends Route {
  @service declare aiAgentSetupService: AiAgentSetupService;

  beforeModel() {
    this.aiAgentSetupService.reloadSalesStatus();
  }
}
